import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import ActivityForm from './ActivityForm'; // ggf. anpassen
import PipelineDocumentLinkForm from './PipelineDocumentLinkForm';
import AssetForm from './AssetForm'; // ggf. Pfad anpassen!

// Utils
const getName = (obj) => {
  if (!obj) return '-';
  if (obj.name) return obj.name;
  if (obj.firstName || obj.lastName)
    return `${obj.firstName || ''} ${obj.lastName || ''}`.trim();
  if (obj.contactFirstName || obj.contactLastName)
    return `${obj.contactFirstName || ''} ${obj.contactLastName || ''}`.trim();
  if (obj.company) return obj.company;
  return '-';
};

const PROSPECT_STATUS_OPTIONS = [
  { value: 'neu', label: 'Neu' },
  { value: 'kontaktiert', label: 'Kontaktiert' },
  { value: 'qualifiziert', label: 'Qualifiziert' },
  { value: 'verloren', label: 'Verloren' },
  { value: 'konvertiert', label: 'Konvertiert' },
];

// Simple Modal
function SimpleModal({
  open,
  onClose,
  children,
  wide = false,
  tall = false,
  extraWide = false,
}) {
  if (!open) return null;
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      background: "rgba(0,0,0,0.22)", display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999, padding: extraWide ? 4 : 16, boxSizing: "border-box", overflow: "hidden"
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 10,
        width: extraWide ? "calc(100vw - 8px)" : (wide ? "100%" : "auto"),
        height: tall ? "calc(100vh - 32px)" : "auto",
        minWidth: wide ? 0 : 350,
        maxWidth: extraWide
          ? "calc(100vw - 8px)"
          : (wide ? 1500 : "calc(100vw - 32px)"),
        maxHeight: extraWide ? "calc(100vh - 8px)" : "calc(100vh - 32px)",
        padding: extraWide ? 16 : 28,
        boxSizing: "border-box",
        overflowY: "auto",
        overflowX: extraWide ? "hidden" : "auto",
        boxShadow: "0 2px 16px rgba(0,0,0,0.13)",
        position: "relative"
      }}>
        <button
  onClick={onClose}
  style={{
    position: 'absolute',
    top: 11,
    right: 16,
    fontSize: 32,         // gerne etwas größer machen!
    color: "#e03131",     // satte Rot-Farbe, #e03131 ist modern und auffällig
    border: "none",
    background: "none",
    cursor: "pointer",
    fontWeight: "bold",
    lineHeight: 1,
    padding: 0
  }}
  aria-label="Schließen"
>×</button>
        {children}
      </div>
    </div>
  );
}

// Instanz-Bearbeitung
function EditInstanceForm({ instance, onClose, onSaved }) {
  const [form, setForm] = useState({ ...instance });
  const [pipelines, setPipelines] = useState([]);
  const [stages, setStages] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState(null); 
  
  

  useEffect(() => {
    api.get('/pipeline-definitions').then(res => setPipelines(res.data));
    api.get('/users').then(res => setUsers(res.data));
    if (form.customerId) {
      api.get(`/contacts/customer/${form.customerId}`).then(res => setContacts(res.data));
    } else if (form.prospectId) {
      api.get(`/prospects/${form.prospectId}/contacts`).then(res => setContacts(res.data));
    } else {
      setContacts([]);
    }
  }, [form.customerId, form.prospectId]);

  useEffect(() => {
    if (!form.pipelineDefId) return setStages([]);
    api.get('/pipeline-stages', { params: { pipelineDefId: form.pipelineDefId } })
      .then(res => setStages(res.data.sort((a, b) => a.order - b.order)))
      .catch(() => setStages([]));
  }, [form.pipelineDefId]);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.put(`/pipeline-instances/${instance.id}`, form);
      if (onSaved) onSaved();
    } catch {
      setError("Fehler beim Speichern");
    } finally {
      setLoading(false);
    }
  };

   // DELETE-Handler
  const handleDelete = async () => {
    if (!window.confirm("Wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden!")) return;
    setDeleteLoading(true);
    setDeleteError(null);
    try {
      await api.delete(`/pipeline-instances/${instance.id}`);
      if (onSaved) onSaved(); // Instanzenliste aktualisieren
      if (onClose) onClose(); // Modal schließen
    } catch (err) {
      setDeleteError("Fehler beim Löschen! " + (err?.response?.data?.error || ""));
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <h3>Deal bearbeiten</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <input
          name="name"
          value={form.name || ""}
          onChange={handleChange}
          placeholder="Deal-Name"
        />
        <select
          name={form.prospectId ? "prospectContactId" : "contactId"}
          value={(form.prospectId ? form.prospectContactId : form.contactId) || ""}
          onChange={handleChange}
          style={{
marginLeft:"0px" 
  }}
        >
          <option value="">Ansprechpartner wählen</option>
          {contacts.map(c => (
            <option key={c.id} value={c.id}>
              {c.contactFirstName || c.firstName || ""} {c.contactLastName || c.lastName || ""}
            </option>
          ))}
        </select>
        <select
          name="pipelineDefId"
          value={form.pipelineDefId || ""}
          onChange={handleChange}
          style={{
marginLeft:"0px" 
  }}
        >
          <option value="">Pipeline wählen</option>
          {pipelines.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>
        <select
          name="currentStageId"
          value={form.currentStageId || ""}
          onChange={handleChange}
          style={{
marginLeft:"0px" 
  }}
        >
          <option value="">Phase wählen</option>
          {stages.map(s => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>
        <input
          type="number"
          name="value"
          value={form.value || ""}
          onChange={handleChange}
          placeholder="Wert (€)"
        />
        <input
          type="number"
          name="probability"
          value={form.probability || ""}
          onChange={handleChange}
          placeholder="Wahrscheinlichkeit (%)"
        />
        <select
          name="responsibleUser"
          value={form.responsibleUser || ""}
          onChange={handleChange}
          style={{
marginLeft:"0px" ,
marginTop:"0px" ,

  }}
        >
          <option value="">Verantwortlich</option>
          {users.map(u => (
            <option key={u.id} value={u.id}>{u.firstName} {u.lastName}</option>
          ))}
        </select>
        <div style={{ display: "flex", gap: 8 }}>
          <button type="submit" style={{ background: "#2eae4a", color: "#fff", padding: "8px 16px", border: "none", borderRadius: 5 }} disabled={loading}>
            Speichern
          </button>
          <button type="button" onClick={onClose} style={{ background: "#eee", color: "#333", padding: "8px 16px", border: "none", borderRadius: 5 }}>
            Abbrechen
          </button>
          <button
            type="button"
            onClick={handleDelete}
            style={{
              background: "#e03131",
              color: "#fff",
              padding: "8px 16px",
              border: "none",
              borderRadius: 5,
              marginLeft: "auto"
            }}
            disabled={deleteLoading}
          >
            {deleteLoading ? "Lösche..." : "Löschen"}
          </button>
        </div>
        {error && <div style={{ color: "red" }}>{error}</div>}
         {deleteError && <div style={{ color: "red" }}>{deleteError}</div>}
      </div>
    </form>
  );
}

// Deal-anlegen-Formular (Modal)
function AddInstanceForm({ customer, prospect, onClose, onCreated }) {
  const account = customer || prospect;
  const isProspect = !!prospect;
  const [pipelines, setPipelines] = useState([]);
  const [stages, setStages] = useState([]);
  const [users, setUsers] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [form, setForm] = useState({
    name: "",
    pipelineDefId: "",
    currentStageId: "",
    contactId: "",
    prospectContactId: "",
    value: "",
    probability: "",
    responsibleUser: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/pipeline-definitions').then(res => setPipelines(res.data));
    api.get('/users').then(res => setUsers(res.data));
    const contactsRequest = isProspect
      ? api.get(`/prospects/${prospect.id}/contacts`)
      : api.get(`/contacts/customer/${customer.id}`);
    contactsRequest.then(res => setContacts(res.data));
  }, [customer, prospect, isProspect]);

  useEffect(() => {
    if (!form.pipelineDefId) return setStages([]);
    api.get('/pipeline-stages', { params: { pipelineDefId: form.pipelineDefId } })
      .then(res => setStages(res.data.sort((a, b) => a.order - b.order)))
      .catch(() => setStages([]));
  }, [form.pipelineDefId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.pipelineDefId || !form.currentStageId) {
      setError("Bitte Name, Pipeline und Phase wählen!");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await api.post('/pipeline-instances', {
        ...form,
        customerId: isProspect ? null : customer.id,
        prospectId: isProspect ? prospect.id : null,
        contactId: isProspect ? null : (form.contactId || null),
        prospectContactId: isProspect ? (form.prospectContactId || null) : null,
        status: 'open'
      });
      if (onCreated) onCreated();
    } catch (err) {
      setError(
        err.response?.data?.error
        || err.response?.data?.message
        || "Fehler beim Anlegen."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <h3>Deal anlegen für {account.company}</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <input
          type="text"
          placeholder="Deal-Name"
          value={form.name}
          onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
          required
        />
        <select
          value={isProspect ? form.prospectContactId : form.contactId}
          onChange={e => setForm(f => ({
            ...f,
            [isProspect ? 'prospectContactId' : 'contactId']: e.target.value,
          }))}
        >
          <option value="">Ansprechpartner wählen</option>
          {contacts.map(c => (
            <option key={c.id} value={c.id}>
              {c.contactFirstName || c.firstName || ""} {c.contactLastName || c.lastName || ""}
            </option>
          ))}
        </select>
        <select
          value={form.pipelineDefId}
          onChange={e => setForm(f => ({ ...f, pipelineDefId: e.target.value, currentStageId: "" }))}
          required
        >
          <option value="">Pipeline wählen</option>
          {pipelines.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>
        <select
          value={form.currentStageId}
          onChange={e => setForm(f => ({ ...f, currentStageId: e.target.value }))}
          required
          disabled={!form.pipelineDefId}
        >
          <option value="">Phase wählen</option>
          {stages.map(s => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>
        <input
          type="number"
          placeholder="Wert (€)"
          value={form.value}
          min={0}
          onChange={e => setForm(f => ({ ...f, value: e.target.value }))}
        />
        <input
          type="number"
          placeholder="Wahrscheinlichkeit (%)"
          value={form.probability}
          min={0} max={100}
          onChange={e => setForm(f => ({ ...f, probability: e.target.value }))}
        />
        <select
          value={form.responsibleUser}
          onChange={e => setForm(f => ({ ...f, responsibleUser: e.target.value }))}
        >
          <option value="">Verantwortlich</option>
          {users.map(u => (
            <option key={u.id} value={u.id}>{u.firstName} {u.lastName}</option>
          ))}
        </select>
        {error && <div style={{ color: "red" }}>{error}</div>}
        <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
          <button type="submit" style={{ background: "#2eae4a", color: "#fff", padding: "8px 16px", border: "none", borderRadius: 5 }} disabled={loading}>
            Deal anlegen
          </button>
          <button type="button" onClick={onClose} style={{ background: "#eee", color: "#333", padding: "8px 16px", border: "none", borderRadius: 5 }}>
            Abbrechen
          </button>
        </div>
      </div>
    </form>
  );
}



function EditContactForm({ contact, onClose, onSaved }) {
  const [form, setForm] = useState({ ...contact });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.put(`/contacts/${contact.id}`, form);
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      setError("Fehler beim Speichern");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <h3>Ansprechpartner bearbeiten</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <input name="contactFirstName" value={form.contactFirstName || ""} onChange={handleChange} placeholder="Vorname" />
        <input name="contactLastName" value={form.contactLastName || ""} onChange={handleChange} placeholder="Nachname" />
        <input name="contactEmail" value={form.contactEmail || ""} onChange={handleChange} placeholder="E-Mail" />
        <input name="contactPhone" value={form.contactPhone || ""} onChange={handleChange} placeholder="Telefon" />
        <input name="contactMobile" value={form.contactMobile || ""} onChange={handleChange} placeholder="Mobil" />

        {/* NEU: CRM-Rolle */}
        <input
          name="crmRole"
          value={form.crmRole || ""}
          onChange={handleChange}
          placeholder="CRM-Rolle (z.B. Geschäftsführer, Einkauf, etc.)"
        />

        {/* NEU: Hauptansprechpartner */}
        <label style={{ display: "flex", alignItems: "center", gap: 7 }}>
          <input
            type="checkbox"
            name="isMainContact"
            checked={!!form.isMainContact}
            onChange={handleChange}
          />
          Hauptansprechpartner
        </label>

        {/* NEU: Notizen */}
        <textarea
          name="notes"
          value={form.notes || ""}
          onChange={handleChange}
          placeholder="Notizen"
          rows={3}
        />

        {/* NEU: Geburtstag */}
        <input
          type="date"
          name="birthday"
          value={form.birthday || ""}
          onChange={handleChange}
          placeholder="Geburtstag"
        />

        {error && <div style={{ color: "red" }}>{error}</div>}
        <div style={{ display: "flex", gap: 8 }}>
          <button type="submit" style={{ background: "#2eae4a", color: "#fff", padding: "8px 16px", border: "none", borderRadius: 5 }} disabled={loading}>Speichern</button>
          <button type="button" onClick={onClose} style={{ background: "#eee", color: "#333", padding: "8px 16px", border: "none", borderRadius: 5 }}>Abbrechen</button>
        </div>
      </div>
    </form>
  );
}

function ContactOverviewModal({ customer, onClose, onContactSaved }) {
  const [contacts, setContacts] = useState([]);
  const [editContact, setEditContact] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!customer?.id) return;
    setLoading(true);
    api.get(`/contacts/customer/${customer.id}`)
      .then(res => setContacts(res.data))
      .finally(() => setLoading(false));
  }, [customer]);

  // Falls Bearbeitung aktiv ist: zeige das Edit-Formular im Modal
  if (editContact) {
    return (
      <EditContactForm
        contact={editContact}
        onClose={() => setEditContact(null)}
        onSaved={() => {
          setEditContact(null);
          // Nach Save, Kontakte neu laden:
          api.get(`/contacts/customer/${customer.id}`).then(res => setContacts(res.data));
          // Ggf. noch die Parent informieren:
          if (onContactSaved) onContactSaved();
        }}
      />
    );
  }

  return (
    <div>
      <h3>Ansprechpartner für <span style={{color: "#2eae4a"}}>{customer.company}</span></h3>
      {loading ? (
        <div>Lade Ansprechpartner ...</div>
      ) : contacts.length === 0 ? (
        <div>Keine Ansprechpartner hinterlegt.</div>
      ) : (
        <table style={{ minWidth: 600, marginBottom: 10 }}>
          <thead>
            <tr>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>E-Mail</th>
              <th>Telefon</th>
              <th>Mobil</th>
              <th>Funktion</th>
              <th>CRM-Rolle</th>
              <th>Hauptkontakt</th>
              <th>Geburtstag</th>
              <th>Notizen</th>
              <th>Aktion</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map(c => (
              <tr key={c.id}>
                <td>{c.contactFirstName}</td>
                <td>{c.contactLastName}</td>
                <td>{c.contactEmail}</td>
                <td>{c.contactPhone}</td>
                <td>{c.contactMobile}</td>
                <td>{c.contactFunction}</td>
                <td>{c.crmRole}</td>
                <td>{c.isMainContact ? "✔️" : ""}</td>
                <td>{c.birthday ? new Date(c.birthday).toLocaleDateString() : ""}</td>
                <td style={{maxWidth: 150, whiteSpace: 'pre-wrap'}}>{c.notes}</td>
                <td>
                  <button
                    style={{ background: "#3b82f6", color: "#fff", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer" }}
                    onClick={() => setEditContact(c)}
                  >
                    Bearbeiten
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <button
        style={{ background: "#eee", color: "#333", padding: "7px 20px", border: "none", borderRadius: 5 }}
        onClick={onClose}
      >Schließen</button>
    </div>
  );
}


const limit = 25;

// HIER den neuen Code einfügen:
function ContactEditModal({ modalState, onClose, onSaved }) {
  const { customer } = modalState;
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editContact, setEditContact] = useState(null);

  useEffect(() => {
    if (customer?.id) {
      api.get(`/contacts/customer/${customer.id}`)
        .then(res => setContacts(res.data))
        .finally(() => setLoading(false));
    }
  }, [customer]);

  if (loading) return <div>Lädt Ansprechpartner ...</div>;

  if (editContact) {
    return (
      <EditContactForm
        contact={editContact}
        onClose={() => setEditContact(null)}
        onSaved={() => {
          setEditContact(null);
          // Nach dem Speichern Kontakte neu laden
          api.get(`/contacts/customer/${customer.id}`)
            .then(res => setContacts(res.data));
          if (onSaved) onSaved();
        }}
      />
    );
  }

  return (
    <div>
      <h3>Ansprechpartner für {customer.company}</h3>
      {contacts.length === 0 && <div>Keine Ansprechpartner vorhanden.</div>}
      <ul>
        {contacts.map(ct => (
          <li key={ct.id}>
            <span
              style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
              onClick={() => setEditContact(ct)}
              title="Bearbeiten"
            >
              {ct.contactFirstName} {ct.contactLastName} ({ct.contactEmail || 'ohne E-Mail'})
            </span>
          </li>
        ))}
      </ul>
      <button
        style={{ background: "#2eae4a", color: "#fff", border: "none", borderRadius: 5, marginTop: 12, padding: "8px 16px" }}
        onClick={() => setEditContact({ customerId: customer.id })}>
        + Neuer Ansprechpartner
      </button>
      <button style={{ marginLeft: 12 }} onClick={onClose}>Schließen</button>
    </div>
  );
}

const PipelineInstanceForm = () => {
  // Menü & Views
  // Tab speichern
const [tab, setTab] = useState(() => {
  return localStorage.getItem('crmTab') || 'pipelines';
});
// Pipeline speichern
const [pipelineView, setPipelineView] = useState(() => {
  const pv = localStorage.getItem('crmPipelineView');
  return pv ? JSON.parse(pv) : null;
});
// Stage speichern
const [activeStage, setActiveStage] = useState(() => {
  const st = localStorage.getItem('crmActiveStage');
  return st ? JSON.parse(st) : null;
});
// Page speichern
const [instancePage, setInstancePage] = useState(() => {
  return parseInt(localStorage.getItem('crmInstancePage'), 10) || 1;
});

useEffect(() => {
  localStorage.setItem('crmTab', tab);
}, [tab]);

useEffect(() => {
  localStorage.setItem('crmPipelineView', pipelineView ? JSON.stringify(pipelineView) : "");
}, [pipelineView]);

useEffect(() => {
  localStorage.setItem('crmActiveStage', activeStage ? JSON.stringify(activeStage) : "");
}, [activeStage]);

useEffect(() => {
  localStorage.setItem('crmInstancePage', instancePage);
}, [instancePage]);

  // Daten
  const [customers, setCustomers] = useState([]);
  const [prospects, setProspects] = useState([]);
  const [prospectFilters, setProspectFilters] = useState({
    query: '',
    status: null,
    origin: null,
    category: null,
    group: null,
    responsible: null,
  });
  const [prospectFilterOptions, setProspectFilterOptions] = useState({
    origins: [],
    categories: [],
    groups: [],
    users: [],
  });
  const [prospectPage, setProspectPage] = useState(1);
  const [prospectPages, setProspectPages] = useState(1);
  const [pipelines, setPipelines] = useState([]);
  const [pipelineStages, setPipelineStages] = useState([]);
  const [pipelineInstanceCounts, setPipelineInstanceCounts] = useState([]);
  const [instances, setInstances] = useState([]);
  const [modalInstance, setModalInstance] = useState(null);
  const [contactEditModal, setContactEditModal] = useState(null); // Neu: Kontaktbearbeitung
  
  const [instanceLimit] = useState(25); // oder wie viele du willst
  const [instanceTotal, setInstanceTotal] = useState(0);

  const [pipelineFilters, setPipelineFilters] = useState({
  customer: null,
  prospect: null,
  status: null,
  responsible: null,
  contact: null,
  prospectContact: null,
  email: "",
  phone: "",
  mobile: "",
  valueMin: "",
  valueMax: "",
  project: ""
});
const [pipelineFilterDraft, setPipelineFilterDraft] = useState(pipelineFilters);
useEffect(() => {
  setPipelineFilterDraft(pipelineFilters);
}, [pipelineFilters]);

useEffect(() => {
  const timeout = setTimeout(() => {
    setPipelineFilters(pipelineFilterDraft);
  }, 400); // 400 ms nach letzter Eingabe

  return () => clearTimeout(timeout);
}, [pipelineFilterDraft]);

  const [pipelineFilterOptions, setPipelineFilterOptions] = useState({
    customers: [],
    prospects: [],
    statuses: [],
    responsibles: [],
  });

  // NEU: Activity-Modal State
  const [activityModalInstance, setActivityModalInstance] = useState(null);
  const [documentModalInstance, setDocumentModalInstance] = useState(null);
  const [assetModalInstance, setAssetModalInstance] = useState(null);


  // Filter, Pagination, Data Fetching wie gehabt
  const [filters, setFilters] = useState(() => {
    const stored = localStorage.getItem('customerListFilters');
    return stored
      ? JSON.parse(stored)
      : { customerNumber: null, company: null, city: null, customerOrigin: null, customerCategory: null, customerGroup: null, customerStatusCrm: null,  };
  });
  useEffect(() => {
    localStorage.setItem('customerListFilters', JSON.stringify(filters));
  }, [filters]);
  const [serverFilterOptions, setServerFilterOptions] = useState({
    customerNumbers: [],
    companies: [],
    cities: [],
    origins: [],     
  categories: [],     
  groups: [],
    statusCrm: []       
  });
  useEffect(() => {
  if (tab !== "contacts") return;
  api.get('/customers/filter-options')
    .then(res => setServerFilterOptions({
      customerNumbers: res.data.customerNumbers || [],
      companies: res.data.companies || [],
      cities: res.data.cities || [],
      origins: res.data.origins || [],
      categories: res.data.categories || [],
      groups: res.data.groups || [],
      statusCrm: res.data.statusCrm || [] 
    }))
    .catch(() => {
      setServerFilterOptions({
        customerNumbers: [],
        companies: [],
        cities: [],
        origins: [],
        categories: [],
        groups: [],
        statusCrm: []
      });
    });
}, [tab]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(true);
  const [prospectsLoading, setProspectsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Kunden laden (mit Filter/Pagination)
  useEffect(() => {
    if (tab !== 'contacts') return;
    setLoading(true);
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('page', currentPage);
    if (filters.customerNumber) params.append('customerNumber', filters.customerNumber.value);
    if (filters.company) params.append('company', filters.company.value);
    if (filters.city) params.append('city', filters.city.value);
    // HIER jetzt die neuen Filter ergänzen:
  if (filters.customerOrigin) params.append('customerOriginId', filters.customerOrigin.value);
  if (filters.customerCategory) params.append('customerCategoryId', filters.customerCategory.value);
  if (filters.customerGroup) params.append('customerGroupId', filters.customerGroup.value);
  if (filters.customerStatusCrm) params.append('statusCrm', filters.customerStatusCrm.value);

    api.get(`/customers/list?${params.toString()}`)
      .then(res => {
        setCustomers(res.data.data);
        setTotalPages(res.data.pages);
      })
      .catch(() => setCustomers([]))
      .finally(() => setLoading(false));
  }, [tab, filters, currentPage]);

  // Pipelines laden
  useEffect(() => {
    if (tab !== 'pipelines') return;
    setLoading(true);
    api.get('/pipeline-definitions')
      .then(res => setPipelines(res.data))
      .catch(() => setError('Fehler beim Laden der Pipelines'))
      .finally(() => setLoading(false));
  }, [tab]);

  useEffect(() => {
    if (tab !== 'prospects') return;

    Promise.all([
      api.get('/customerOrigins'),
      api.get('/customerCategories'),
      api.get('/customerGroups'),
      api.get('/users'),
    ]).then(([origins, categories, groups, users]) => {
      setProspectFilterOptions({
        origins: origins.data || [],
        categories: categories.data || [],
        groups: groups.data || [],
        users: Array.isArray(users.data?.rows) ? users.data.rows : users.data || [],
      });
    }).catch(() => {
      setProspectFilterOptions({
        origins: [],
        categories: [],
        groups: [],
        users: [],
      });
    });
  }, [tab]);

  useEffect(() => {
    if (tab !== 'prospects') return undefined;

    setLoading(false);
    let cancelled = false;
    const timeoutId = window.setTimeout(() => {
      setProspectsLoading(true);
      api.get('/prospects', {
        params: {
          q: prospectFilters.query.trim() || undefined,
          status: prospectFilters.status?.value || undefined,
          customerOriginId: prospectFilters.origin?.value || undefined,
          customerCategoryId: prospectFilters.category?.value || undefined,
          customerGroupId: prospectFilters.group?.value || undefined,
          responsibleUser: prospectFilters.responsible?.value || undefined,
          page: prospectPage,
          limit,
        },
      })
        .then(res => {
          if (cancelled) return;
          setProspects(res.data.rows || []);
          setProspectPages(res.data.pages || 1);
        })
        .catch(() => {
          if (cancelled) return;
          setProspects([]);
          setProspectPages(1);
        })
        .finally(() => {
          if (!cancelled) setProspectsLoading(false);
        });
    }, 250);

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [tab, prospectFilters, prospectPage]);

  // Wenn Pipeline gewählt, Stages & Counter laden
  useEffect(() => {
    if (!pipelineView) return;
    setLoading(true);
    api.get(`/pipeline-stages`, { params: { pipelineDefId: pipelineView.id } })
      .then(res => setPipelineStages(res.data.sort((a, b) => a.order - b.order)))
      .catch(() => setPipelineStages([]));
    api.get(`/pipeline-definitions/${pipelineView.id}/stage-counts`)
      .then(res => setPipelineInstanceCounts(res.data))
      .catch(() => setPipelineInstanceCounts([]))
      .finally(() => setLoading(false));
  }, [pipelineView]);

  const lastPipelineViewId = React.useRef(null);

useEffect(() => {
  if (!pipelineView) return;
  api.get(`/pipeline-instances/${pipelineView.id}/filter-options`)
    .then(res => setPipelineFilterOptions(res.data))
    .catch(() => setPipelineFilterOptions({ customers: [], statuses: [], responsibles: [] }));

  // Filter NUR zurücksetzen, wenn die Pipeline wirklich gewechselt wurde!
  if (lastPipelineViewId.current !== pipelineView.id) {
    setPipelineFilters({
      customer: null,
      prospect: null,
      status: null,
      responsible: null,
      contact: null,
      prospectContact: null,
      email: "",
      phone: "",
      mobile: "",
      valueMin: "",
      valueMax: "",
      project: ""
    });
    lastPipelineViewId.current = pipelineView.id;
  }
}, [pipelineView]);




// Instanzen für Stage (mit Pagination & Filtern)
useEffect(() => {
  if (!pipelineView || !activeStage) return;
  setLoading(true);

  // Filter-Parameter dynamisch zusammenbauen
  const params = {
    stageId: activeStage.id,
    page: instancePage,
    limit: instanceLimit
  };
  if (pipelineFilters.customer) params.customerId = pipelineFilters.customer.value;
if (pipelineFilters.prospect) params.prospectId = pipelineFilters.prospect.value;
if (pipelineFilters.status) params.status = pipelineFilters.status.value;
if (pipelineFilters.responsible) params.responsibleUser = pipelineFilters.responsible.value;
if (pipelineFilters.contact) params.contactId = pipelineFilters.contact.value;
if (pipelineFilters.prospectContact) params.prospectContactId = pipelineFilters.prospectContact.value;
if (pipelineFilters.email) params.email = pipelineFilters.email;
if (pipelineFilters.phone) params.phone = pipelineFilters.phone;
if (pipelineFilters.mobile) params.mobile = pipelineFilters.mobile;
if (pipelineFilters.valueMin) params.valueMin = pipelineFilters.valueMin;
if (pipelineFilters.valueMax) params.valueMax = pipelineFilters.valueMax;
if (pipelineFilters.project) params.project = pipelineFilters.project;
console.log("API-Filter-Params:", params);
  api.get(`/pipeline-instances/${pipelineView.id}/instances`, { params })
    .then(res => {
      console.log("PipelineInstanz-API Antwort:", res.data); // Debug!
      setInstances(Array.isArray(res.data.rows) ? res.data.rows : []);
      setInstanceTotal(Number(res.data.total) || 0);
    })
    .catch(() => {
      setInstances([]);
      setInstanceTotal(0);
    })
    .finally(() => setLoading(false));
}, [
  pipelineView,
  activeStage,
  instancePage,
  instanceLimit,
  pipelineFilters // <--- NEU, damit bei Filter-Änderung neu geladen wird!
]);

  const updateProspectFilter = (field, value) => {
    setProspectFilters(current => ({ ...current, [field]: value }));
    setProspectPage(1);
  };

  // Counter an Stage mappen
  const stagesWithCount = pipelineStages.map(stage => ({
    ...stage,
    count: pipelineInstanceCounts.find(sc => sc.stageId === stage.id)?.count || 0
  }));

  if (loading) return <div>Lade Daten ...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div style={{ margin: "0 10px" }}>
      <Helmet>
        <title>CRM Übersicht</title>
      </Helmet>

      {/* Untermenü */}
      <div style={{ display: "flex", gap: 18, marginBottom: 25 }}>
       <button
  onClick={() => { setTab('contacts'); setPipelineView(null); }}
  style={{
    fontWeight: tab === 'contacts' ? 'bold' : 400,
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
   
    background: "none",
    fontSize: 19,
    cursor: "pointer",
    color: "#222"
  }}>
  Kontakte
</button>
<button
  onClick={() => { setTab('prospects'); setPipelineView(null); }}
  style={{
    fontWeight: tab === 'prospects' ? 'bold' : 400,
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    background: "none",
    fontSize: 19,
    cursor: "pointer",
    color: "#222"
  }}>
  Interessenten
</button>
<button
  onClick={() => { setTab('pipelines'); setPipelineView(null); }}
  style={{
    fontWeight: tab === 'pipelines' ? 'bold' : 400,
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    
    background: "none",
    fontSize: 19, 
    cursor: "pointer", 
    color: "#222"
  }}>
  Pipelines
</button>
      </div>

      {/* Kontakte-Tab */}
      {tab === 'contacts' && (
        <>
          <h2>Kunden / Kontakte</h2>

          {/* Filterleiste */}
          <div style={{ marginBottom: '20px' }}>
            <h3>Filter</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '10px' }}>
              <Select
                options={serverFilterOptions.customerNumbers.map(val => ({ value: val, label: val }))}
                placeholder="Kundennummer"
                isClearable
                value={filters.customerNumber}
                onChange={(selected) => setFilters({ ...filters, customerNumber: selected })}
              />
              <Select
                options={serverFilterOptions.companies.map(val => ({ value: val, label: val }))}
                placeholder="Kundenname"
                isClearable
                value={filters.company}
                onChange={(selected) => setFilters({ ...filters, company: selected })}
              />
              <Select
                options={serverFilterOptions.cities.map(val => ({ value: val, label: val }))}
                placeholder="Ort"
                isClearable
                value={filters.city}
                onChange={(selected) => setFilters({ ...filters, city: selected })}
              />
               {/* NEU: Herkunft */}
  <Select
    options={serverFilterOptions.origins?.map(val => ({ value: val.id, label: val.name })) || []}
    placeholder="Herkunft"
    isClearable
    value={filters.customerOrigin}
    onChange={selected => setFilters({ ...filters, customerOrigin: selected })}
  />
  {/* NEU: Kategorie */}
  <Select
    options={serverFilterOptions.categories?.map(val => ({ value: val.id, label: val.name })) || []}
    placeholder="Kategorie"
    isClearable
    value={filters.customerCategory}
    onChange={selected => setFilters({ ...filters, customerCategory: selected })}
  />
  {/* NEU: Gruppe */}
  <Select
    options={serverFilterOptions.groups?.map(val => ({ value: val.id, label: val.name })) || []}
    placeholder="Gruppe"
    isClearable
    value={filters.customerGroup}
    onChange={selected => setFilters({ ...filters, customerGroup: selected })}
  />
  {/* NEU: CRM Status */}
  <Select
  options={serverFilterOptions.statusCrm || []}
  placeholder="CRM-Status"
  isClearable
  value={filters.customerStatusCrm}
  onChange={selected => setFilters({ ...filters, customerStatusCrm: selected })}
/>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>Kundennummer</th>
                <th>Kundenname</th>
                <th>PLZ</th>
                <th>Ort</th>
                <th>Herkunft</th>     
    <th>Kategorie</th>      
    <th>Gruppe</th>   
    <th>CRM-Status</th>    
                <th>E-Mail</th>
                <th>Telefon</th>
                <th>Aktion</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id}>
                  <td>{c.customerNumber}</td>
                  <td>
  <span
    style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
    onClick={() => setContactEditModal(c)}
    title="Ansprechpartner bearbeiten"
  >
    {c.company}
  </span>
</td>
                  <td>{c.postalCode}</td>
                  <td>{c.city}</td>
                  <td>{c.origin?.name || '-'}</td>     
                  <td>{c.category?.name || '-'}</td>  
                  <td>{c.group?.name || '-'}</td>   
                  <td>{c.statusCrm || '-'}</td>  
                  <td>{c.email}</td>
                  <td>{c.phone}</td>
                  <td>
                    <button
                      style={{
                        padding: "4px 10px",
                        borderRadius: 5,
                        background: "#2eae4a",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer"
                      }}
                      onClick={() => setModalInstance({ mode: "add", customer: c })}
                    >
                      + Deal anlegen
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div style={{ marginTop: '1rem' }}>
            <button
              onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
              disabled={currentPage === 1}
              style={{
                fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgb(155, 155, 155)',
                border: 'none', borderRadius: '5px', cursor: 'pointer'
              }}>
              Vorherige
            </button>
            <span style={{ margin: '0 1rem' }}>
              Seite {currentPage} von {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage >= totalPages}
              style={{
                fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgb(155, 155, 155)',
                border: 'none', borderRadius: '5px', cursor: 'pointer'
              }}>
              Nächste
            </button>
          </div>
        </>
      )}

      {tab === 'prospects' && (
        <>
          <h2>Interessenten</h2>

          <div style={{ marginBottom: '20px' }}>
            <h3>Filter</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '10px' }}>
              <input
                value={prospectFilters.query}
                onChange={event => updateProspectFilter('query', event.target.value)}
                placeholder="Firma, Name, Ort oder E-Mail"
                style={{ height: 38, margin: 0 }}
              />
              <Select
                options={PROSPECT_STATUS_OPTIONS}
                placeholder="Status"
                isClearable
                value={prospectFilters.status}
                onChange={selected => updateProspectFilter('status', selected)}
              />
              <Select
                options={prospectFilterOptions.origins.map(item => ({ value: item.id, label: item.name }))}
                placeholder="Herkunft"
                isClearable
                value={prospectFilters.origin}
                onChange={selected => updateProspectFilter('origin', selected)}
              />
              <Select
                options={prospectFilterOptions.categories.map(item => ({ value: item.id, label: item.name }))}
                placeholder="Kategorie"
                isClearable
                value={prospectFilters.category}
                onChange={selected => updateProspectFilter('category', selected)}
              />
              <Select
                options={prospectFilterOptions.groups.map(item => ({ value: item.id, label: item.name }))}
                placeholder="Gruppe"
                isClearable
                value={prospectFilters.group}
                onChange={selected => updateProspectFilter('group', selected)}
              />
              <Select
                options={prospectFilterOptions.users.map(user => ({
                  value: user.id,
                  label: getName(user) || `#${user.id}`,
                }))}
                placeholder="Verantwortlicher"
                isClearable
                value={prospectFilters.responsible}
                onChange={selected => updateProspectFilter('responsible', selected)}
              />
            </div>
          </div>

          {prospectsLoading && <div style={{ marginBottom: 10 }}>Lade Interessenten …</div>}

          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Firma</th>
                <th>Ort</th>
                <th>Status</th>
                <th>Herkunft</th>
                <th>Kategorie</th>
                <th>Gruppe</th>
                <th>Verantwortlich</th>
                <th>Ansprechpartner</th>
                <th>Aktion</th>
              </tr>
            </thead>
            <tbody>
              {prospects.map(prospect => (
                <tr key={prospect.id}>
                  <td>I-{prospect.id}</td>
                  <td>{prospect.company}</td>
                  <td>{prospect.city || '-'}</td>
                  <td>
                    {PROSPECT_STATUS_OPTIONS.find(option => option.value === prospect.status)?.label
                      || prospect.status}
                  </td>
                  <td>{prospect.origin?.name || '-'}</td>
                  <td>{prospect.category?.name || '-'}</td>
                  <td>{prospect.group?.name || '-'}</td>
                  <td>{getName(prospect.responsible)}</td>
                  <td>
                    {(prospect.contacts || [])
                      .map(contact => `${contact.contactFirstName} ${contact.contactLastName}`)
                      .join(', ') || '-'}
                  </td>
                  <td>
                    {prospect.status !== 'konvertiert' && (
                      <button
                        style={{
                          padding: "4px 10px",
                          borderRadius: 5,
                          background: "#2eae4a",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer"
                        }}
                        onClick={() => setModalInstance({ mode: "add", prospect })}
                      >
                        + Deal anlegen
                      </button>
                    )}
                  </td>
                </tr>
              ))}
              {!prospects.length && (
                <tr><td colSpan={10} style={{ textAlign: 'center', padding: 20 }}>Keine Interessenten vorhanden.</td></tr>
              )}
            </tbody>
          </table>

          <div style={{ marginTop: '1rem' }}>
            <button
              onClick={() => setProspectPage(value => Math.max(1, value - 1))}
              disabled={prospectPage <= 1}
              style={{
                fontSize: '15px',
                padding: '8px 12px',
                backgroundColor: 'rgb(155, 155, 155)',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Vorherige
            </button>
            <span style={{ margin: '0 1rem' }}>
              Seite {prospectPage} von {prospectPages}
            </span>
            <button
              onClick={() => setProspectPage(value => Math.min(prospectPages, value + 1))}
              disabled={prospectPage >= prospectPages}
              style={{
                fontSize: '15px',
                padding: '8px 12px',
                backgroundColor: 'rgb(155, 155, 155)',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Nächste
            </button>
          </div>
        </>
      )}

      {/* Pipelines */}
      {tab === 'pipelines' && !pipelineView && (
        <>
          <h2>Pipelines</h2>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Beschreibung</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {pipelines.map(p => (
                <tr key={p.id}>
                  <td>{p.id}</td>
                  <td>{p.name}</td>
                  <td>{p.description}</td>
                  <td>
                    <button onClick={() => { setPipelineView(p); setActiveStage(null); }}>Anzeigen</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* Pipeline-Detail-Ansicht */}
      {tab === 'pipelines' && pipelineView && (
        <>
          <div style={{ display: 'flex', alignItems: "center", gap: 10, marginBottom: 8 }}>
            <button onClick={() => { setPipelineView(null); setActiveStage(null); }} style={{ border: "none", background: "none", color: "#007bff", cursor: "pointer", fontSize: 15 }}>← zurück zu Pipelines</button>
            <h2 style={{ margin: 0 }}>{pipelineView.name}</h2>
          </div>
          {/* Phasen-Tabs */}
          <div style={{ display: "flex", gap: 7, marginBottom: 16 }}>
  {stagesWithCount.map(stage => {
    // Hilfsfunktion: Bestimme kontrastreiche Schriftfarbe je nach Stage-Farbe
    const textColor = stage.color
      ? (parseInt(stage.color.replace('#', ''), 16) > 0xffffff / 2 ? "#232323" : "#fff")
      : "#232323";

    return (
      <button
        key={stage.id}
        onClick={() => setActiveStage(stage)}
        style={{
          padding: "7px 15px",
          borderRadius: 6,
          border: stage.id === activeStage?.id ? "2.5px solid #2eae4a" : "1.5px solid #ccc",
          background: stage.color || (stage.id === activeStage?.id ? "#eaffee" : "#fff"),
          fontWeight: stage.id === activeStage?.id ? "bold" : 400,
          cursor: "pointer",
          fontSize: 16,
          color: textColor,
          boxShadow: stage.id === activeStage?.id ? "0 0 0 2px #2eae4a" : "none",
          minWidth: 105
        }}
      >
        {stage.name} ({stage.count})
      </button>
    );
  })}
</div>

{/* Filterleiste */}
{activeStage && (
  <div style={{ margin: "12px 0 22px 0" }}>
    <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
      <Select
        options={pipelineFilterOptions.customers}
        placeholder="Kunde"
        isClearable
        value={pipelineFilterDraft.customer}
        onChange={selected => setPipelineFilterDraft(f => ({ ...f, customer: selected }))}
        styles={{ container: base => ({ ...base, minWidth: 170 }) }}
      />
      <Select
        options={pipelineFilterOptions.prospects || []}
        placeholder="Interessent"
        isClearable
        value={pipelineFilterDraft.prospect}
        onChange={selected => setPipelineFilterDraft(f => ({ ...f, prospect: selected }))}
        styles={{ container: base => ({ ...base, minWidth: 170 }) }}
      />
      <Select
        options={pipelineFilterOptions.statuses}
        placeholder="Status"
        isClearable
        value={pipelineFilterDraft.status}
        onChange={selected => setPipelineFilterDraft(f => ({ ...f, status: selected }))}
        styles={{ container: base => ({ ...base, minWidth: 120 }) }}
      />
      <Select
        options={pipelineFilterOptions.responsibles}
        placeholder="Verantwortlich"
        isClearable
        value={pipelineFilterDraft.responsible}
        onChange={selected => setPipelineFilterDraft(f => ({ ...f, responsible: selected }))}
        styles={{ container: base => ({ ...base, minWidth: 180 }) }}
      />
      <Select
        options={pipelineFilterOptions.contacts || []}
        placeholder="Ansprechpartner"
        isClearable
        value={pipelineFilterDraft.contact}
        onChange={selected => setPipelineFilterDraft(f => ({ ...f, contact: selected }))}
        styles={{ container: base => ({ ...base, minWidth: 170 }) }}
      />
      <Select
        options={pipelineFilterOptions.prospectContacts || []}
        placeholder="Interessenten-Kontakt"
        isClearable
        value={pipelineFilterDraft.prospectContact}
        onChange={selected => setPipelineFilterDraft(f => ({ ...f, prospectContact: selected }))}
        styles={{ container: base => ({ ...base, minWidth: 180 }) }}
      />
      <input
        type="text"
        placeholder="E-Mail"
        value={pipelineFilterDraft.email}
        onChange={e => setPipelineFilterDraft(f => ({ ...f, email: e.target.value }))}
        style={{ marginTop: 15, minWidth: 140 }}
      />
      <input
        type="text"
        placeholder="Telefon"
        value={pipelineFilterDraft.phone}
        onChange={e => setPipelineFilterDraft(f => ({ ...f, phone: e.target.value }))}
        style={{ marginTop: 15,minWidth: 120 }}
      />
      <input
        type="text"
        placeholder="Mobil"
        value={pipelineFilterDraft.mobile}
        onChange={e => setPipelineFilterDraft(f => ({ ...f, mobile: e.target.value }))}
        style={{marginTop: 15, minWidth: 120 }}
      />
      <input
        type="number"
        placeholder="Wert min"
        value={pipelineFilterDraft.valueMin}
        onChange={e => setPipelineFilterDraft(f => ({ ...f, valueMin: e.target.value }))}
        style={{marginTop: 15, minWidth: 80 }}
      />
      <input
        type="number"
        placeholder="Wert max"
        value={pipelineFilterDraft.valueMax}
        onChange={e => setPipelineFilterDraft(f => ({ ...f, valueMax: e.target.value }))}
        style={{marginTop: 15, minWidth: 80 }}
      />
      <input
        type="text"
        placeholder="Deal-Name"
        value={pipelineFilterDraft.project}
        onChange={e => setPipelineFilterDraft(f => ({ ...f, project: e.target.value }))}
        style={{ marginTop: 15,minWidth: 140 }}
      />
      <button
        onClick={() =>
          setPipelineFilterDraft({
            customer: null,
            prospect: null,
            status: null,
            responsible: null,
            contact: null,
            prospectContact: null,
            email: "",
            phone: "",
            mobile: "",
            valueMin: "",
            valueMax: "",
            project: ""
          })
        }
        style={{
          background: "#3b82f6",
          border: "1px solid #ccc",
          borderRadius: 5,
          fontSize: 18,
          padding: "4px 10px",
          cursor: "pointer"
        }}
        title="Alle Filter zurücksetzen"
      >
        X
      </button>
    </div>
  </div>
)}


          {/* Instanzen Tabelle */}
          {activeStage && (
             <>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Kontakt</th>
                  <th>Telefon</th>
                  <th>Mobil</th>
                  <th>Email</th>
                  <th>Kunde</th>
                  <th>Wert</th>
                  <th>Status</th>
                  <th>Verantwortlich</th>
                  <th>Asset</th>  
                  <th>Dokument</th>
                  <th>Aktivität</th>
                  <th>Aktion</th>
                </tr>
              </thead>
              <tbody>
                {instances.map(inst => (
                  <tr
                    key={inst.id}
                    style={{ cursor: "pointer" }}
                    onClick={e => {
                      if (e.target.tagName === 'BUTTON') return;
                      setModalInstance(inst);
                    }}
                  >
                    <td>{inst.id}</td>
                    <td>{inst.name}</td>
                    <td>
                      {(inst.contact || inst.prospectContact)
                        ? `${(inst.contact || inst.prospectContact).contactFirstName || (inst.contact || inst.prospectContact).firstName || ""} ${(inst.contact || inst.prospectContact).contactLastName || (inst.contact || inst.prospectContact).lastName || ""}`.trim()
                        : "-"}
                    </td>
                    <td>
                      {inst.contact?.contactPhone || inst.contact?.phone || inst.prospectContact?.contactPhone || "-"}
                    </td>
                    <td>
                      {inst.contact?.contactMobile || inst.prospectContact?.contactMobile || "-"}
                    </td>
                    <td>
                      {inst.contact?.contactEmail || inst.prospectContact?.contactEmail || "-"}
                    </td>
                    <td>
                      {inst.prospect
                        ? <em>{getName(inst.prospect)}</em>
                        : getName(inst.customer)}
                    </td>
                    <td>{inst.value}</td>
                    <td>{inst.status}</td>
                    <td>
  {inst.responsible
    ? `${inst.responsible.firstName || ""} ${inst.responsible.lastName || ""}`.trim()
    : "-"}
</td>
                    <td>
  <button
    style={{
      padding: "4px 10px",
      borderRadius: 5,
      background: "#aabfff",
      color: "#232323",
      border: "none",
      cursor: "pointer"
    }}
    onClick={e => {
      e.stopPropagation();
      setAssetModalInstance(inst);  // Die ganze Instanz weitergeben
    }}
  >
    Assets
  </button>
</td>
                    <td>
        <button
          style={{
            padding: "4px 10px",
            borderRadius: 5,
            background: "#3b82f6",
            color: "#fff",
            border: "none",
            cursor: "pointer"
          }}
          onClick={e => {
            e.stopPropagation();
            if (!inst.prospectId) setDocumentModalInstance(inst);
          }}
          disabled={!!inst.prospectId}
          title={inst.prospectId ? 'Dokumente können nach der Kundenumwandlung zugeordnet werden.' : ''}
        >
          {inst.prospectId ? 'Nach Umwandlung' : 'Zuordnen'}
        </button>
      </td>
                    <td>
                      <button
                        style={{
                          padding: "4px 10px",
                          borderRadius: 5,
                          background: "#f6c700",
                          color: "#222",
                          border: "none",
                          cursor: "pointer"
                        }}
                        onClick={e => {
                          e.stopPropagation();
                          setActivityModalInstance(inst);
                        }}
                      >
                        Bearbeiten
                      </button>
                    </td>
                    <td>Bearbeiten</td>
                  </tr>
                ))}
                {instances.length === 0 && (
                  <tr>
                    <td colSpan={11} style={{ textAlign: 'center', color: '#aaa', padding: 24 }}>Keine Vorgänge in dieser Phase.</td>
                  </tr>
                )}
              </tbody>
            </table>
          {/* Pagination */}
    <div style={{ margin: "16px 0", textAlign: "center"  }}>
      <button
        onClick={() => setInstancePage(p => Math.max(1, p - 1))}
        disabled={instancePage === 1}
        style={{
          fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgb(155, 155, 155)',
          border: 'none', borderRadius: '5px', cursor: instancePage === 1 ? 'not-allowed' : 'pointer'
        }}>
        Vorherige
      </button>
      <span>
        Seite {instancePage} von {Math.max(1, Math.ceil(instanceTotal / instanceLimit))}
      </span>
      <button
        onClick={() => setInstancePage(p => Math.min(Math.ceil(instanceTotal / instanceLimit), p + 1))}
        disabled={instancePage >= Math.ceil(instanceTotal / instanceLimit)}
        style={{
          fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgb(155, 155, 155)',
          border: 'none', borderRadius: '5px', cursor: instancePage >= Math.ceil(instanceTotal / instanceLimit) ? 'not-allowed' : 'pointer'
        }}>
        Nächste
      </button>
    </div>
  </>
)}

          {/* Modal für Instanz-Details */}
          <SimpleModal open={!!modalInstance} onClose={() => setModalInstance(null)}>
            {modalInstance && modalInstance.mode === "add" ? (
              <AddInstanceForm
                customer={modalInstance.customer}
                prospect={modalInstance.prospect}
                onClose={() => setModalInstance(null)}
                onCreated={instance => {
                  setModalInstance(null);
                  // Optional: Kundenliste oder Pipeline neu laden!
                }}
              />
            ) : modalInstance ? (
              <EditInstanceForm
                instance={modalInstance}
                onClose={() => setModalInstance(null)}
                onSaved={() => {
                  setModalInstance(null);
                  // Instanzen für aktuelle Pipeline+Stage neu laden:
                 if (pipelineView && activeStage) {
    api.get(`/pipeline-definitions/${pipelineView.id}/instances`, { params: { stageId: activeStage.id } })
      .then(res => setInstances(Array.isArray(res.data.rows) ? res.data.rows : []));
                  }
                }}
              />
            ) : null}
          </SimpleModal>

          {/* Modal für Aktivitäten */}
          <SimpleModal
            open={!!activityModalInstance}
            onClose={() => setActivityModalInstance(null)}
            wide
            extraWide
          >
  {activityModalInstance && (
    <ActivityForm
      pipelineInstId={activityModalInstance.id}
      customer={activityModalInstance.customer}
      contact={activityModalInstance.contact}
      prospect={activityModalInstance.prospect}
      prospectContact={activityModalInstance.prospectContact}
      showAddRow={true}
      showFilters={false}
      disableFilterPersistence={true} 
    />
  )}
</SimpleModal>
        </>
      )}

<SimpleModal
  open={!!assetModalInstance}
  onClose={() => setAssetModalInstance(null)}
  wide
  tall
>
  {assetModalInstance && (
    <AssetForm
      pipelineInstId={assetModalInstance.id}
      instanceCustomerId={assetModalInstance.customerId}
      instanceContactId={assetModalInstance.contactId}
      instanceProspectId={assetModalInstance.prospectId}
      instanceProspectContactId={assetModalInstance.prospectContactId}
      showAddRow={true}
      showFilters={false}
    />
  )}
</SimpleModal>

      {/* Modal für Dokument-Links */}
<SimpleModal open={!!documentModalInstance} onClose={() => setDocumentModalInstance(null)}>
  {documentModalInstance && (
    <PipelineDocumentLinkForm
      pipelineInstId={documentModalInstance.id}
    />
  )}
</SimpleModal>

      {/* Modal für Deal anlegen aus Kontakte-Tab */}
      <SimpleModal open={!!modalInstance && modalInstance.mode === "add"} onClose={() => setModalInstance(null)}>
        {modalInstance && modalInstance.mode === "add" && (
          <AddInstanceForm
            customer={modalInstance.customer}
            prospect={modalInstance.prospect}
            onClose={() => setModalInstance(null)}
            onCreated={() => setModalInstance(null)}
          />
        )}
      </SimpleModal>

     <SimpleModal open={!!contactEditModal} onClose={() => setContactEditModal(null)}>
  {contactEditModal && (
    <ContactOverviewModal
      customer={contactEditModal}
      onClose={() => setContactEditModal(null)}
      onContactSaved={() => {
        setContactEditModal(null);
        // Nach dem Speichern ggf. Kundenliste neu laden:
        if (tab === 'contacts') {
          setLoading(true);
          const params = new URLSearchParams();
          params.append('limit', limit);
          params.append('page', currentPage);
          if (filters.customerNumber) params.append('customerNumber', filters.customerNumber.value);
          if (filters.company) params.append('company', filters.company.value);
          if (filters.city) params.append('city', filters.city.value);
          api.get(`/customers/list?${params.toString()}`)
            .then(res => {
              setCustomers(res.data.data);
              setTotalPages(res.data.pages);
            })
            .catch(() => setCustomers([]))
            .finally(() => setLoading(false));
        }
      }}
    />
  )}
</SimpleModal>

    </div>
  );
};



export default PipelineInstanceForm;
